var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "session-duration-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm.fullScreen
        ? _c("h2", [_vm._v(_vm._s(_vm.$t("report.sessionDurationOverall")))])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "middle" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("report.aggregateAs")) + ":")]),
            _vm._v(" "),
            _c(
              "a-radio-group",
              {
                attrs: { size: "small" },
                model: {
                  value: _vm.aggregationType,
                  callback: function ($$v) {
                    _vm.aggregationType = $$v
                  },
                  expression: "aggregationType",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "avg" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("message.average"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "total" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.total"))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("label", [_vm._v(_vm._s(_vm.$t("report.handledBy")))]),
            _vm._v(" "),
            _c(
              "a-radio-group",
              {
                attrs: { size: "small" },
                model: {
                  value: _vm.handleType,
                  callback: function ($$v) {
                    _vm.handleType = $$v
                  },
                  expression: "handleType",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "hybrid" } }, [
                  _vm._v(_vm._s(_vm.$t("report.hybrid"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "chatbot" } }, [
                  _vm._v(_vm._s(_vm.$t("message.chatBot"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "agent" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("billing.agent"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("report.viewUnitAs")) + ":")]),
            _vm._v(" "),
            _c(
              "a-radio-group",
              {
                attrs: { size: "small" },
                model: {
                  value: _vm.unit,
                  callback: function ($$v) {
                    _vm.unit = $$v
                  },
                  expression: "unit",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "seconds" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.second"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "minutes" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.minute"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "hours" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.hour"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _c("EChartsLine", {
            attrs: {
              labels: _vm.getXAxisData(),
              datasets: _vm.getChartDatasets(),
              height: 320,
            },
          }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _vm.aggregationType === "total"
            ? _c("StatCard", {
                attrs: {
                  title: _vm.$t("report.totalSessionDuration"),
                  value: _vm.humanizeDuration(
                    _vm.stats.TotalDuration,
                    _vm.unit
                  ),
                  description: _vm.$t("report.totalSessionDurationDesc"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.handleType === "chatbot" || _vm.handleType === "hybrid") &&
          _vm.aggregationType === "total"
            ? _c("StatCard", {
                attrs: {
                  title: _vm.$t("report.totalDurationByCB"),
                  value: _vm.humanizeDuration(
                    _vm.stats.ChatbotTotalDuration,
                    _vm.unit
                  ),
                  description: _vm.$t("report.totalDurationByCBDesc"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.handleType === "agent" || _vm.handleType === "hybrid") &&
          _vm.aggregationType === "total"
            ? _c("StatCard", {
                attrs: {
                  title: _vm.$t("report.totalDurationByAgent"),
                  value: _vm.humanizeDuration(
                    _vm.stats.AgentTotalDuration,
                    _vm.unit
                  ),
                  description: _vm.$t("report.totalDurationByAgentDesc"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.aggregationType === "avg"
            ? _c("StatCard", {
                attrs: {
                  title: _vm.$t("report.averageSessionDuration"),
                  value: _vm.humanizeDuration(
                    _vm.stats.AverageDuration,
                    _vm.unit
                  ),
                  description: _vm.$t("report.averageSessionDurationDesc"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.handleType === "chatbot" || _vm.handleType === "hybrid") &&
          _vm.aggregationType === "avg"
            ? _c("StatCard", {
                attrs: {
                  title: _vm.$t("report.averageDurationByCB"),
                  value: _vm.humanizeDuration(
                    _vm.stats.ChatbotAverageDuration,
                    _vm.unit
                  ),
                  description: _vm.$t("report.averageDurationByCBDesc"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.handleType === "agent" || _vm.handleType === "hybrid") &&
          _vm.aggregationType === "avg"
            ? _c("StatCard", {
                attrs: {
                  title: _vm.$t("report.averageDurationByAgent"),
                  value: _vm.humanizeDuration(
                    _vm.stats.AgentAverageDuration,
                    _vm.unit
                  ),
                  description: _vm.$t("report.averageDurationByAgentDesc"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.maxDuration"),
              value: _vm.humanizeDuration(_vm.stats.MaxDuration, _vm.unit),
              description: _vm.$t("report.maxDurationDesc"),
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.minDuration"),
              value: _vm.humanizeDuration(_vm.stats.MinDuration, _vm.unit),
              description: _vm.$t("report.minDurationDesc"),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }